import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${API_BASE}/api`;

// In-memory only token store — never persisted to sessionStorage/localStorage
// Tokens are lost on page refresh (user must re-login), but not exfiltrable via XSS
let _adminToken = null;
let _posToken = null;
let _adminUser = null;
let _posUser = null;

/** @param {'admin'|'pos'} type */
export function setToken(type, token) {
  if (type === 'admin') { _adminToken = token; }
  else { _posToken = token; }
}

export function getToken(type) {
  return type === 'admin' ? _adminToken : _posToken;
}

export function setUser(type, user) {
  if (type === 'admin') { _adminUser = user; }
  else { _posUser = user; }
}

export function getUser(type) {
  return type === 'admin' ? _adminUser : _posUser;
}

export function clearAllTokens() {
  _adminToken = null;
  _posToken = null;
  _adminUser = null;
  _posUser = null;
}

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getToken('admin') || getToken('pos');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const screenInfo = `${window.screen.width}x${window.screen.height}`;
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  config.headers['x-device-info'] = `${screenInfo} / ${tz}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const detail = error.response?.data?.detail;
      if (detail === 'SESSION_EXPIRED' || detail === 'TOKEN_EXPIRED') {
        clearAllTokens();
        const path = window.location.pathname;
        window.location.href = path.startsWith('/admin') ? '/admin/login' : '/pos/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE, API };
